import * as ko from "knockout";
import * as _ from "underscore";

import { BaseProperty, IPropertyDescription } from "Core/GeneralProperties/Managers/BaseProperty";
import { IControl } from "Core/Controls/IControl";
import { AttachedFieldModel } from "Core/Controls/BaseControl/Models/AttachedFieldModel";

import Template from "Core/GeneralProperties/Managers/HyperlinkFieldsProperty/Templates/HyperlinkFieldsProperty.html";

ko.templates["Core/GeneralProperties/Managers/HyperlinkFieldsProperty/Templates/HyperlinkFieldsProperty"] = Template;

export interface IHyperlinkFieldsValue {
    Enabled: boolean;
    FieldIds: number[];
}

interface IOptionItem {
    Name: string;
    Value: number;
    IsSelected: KnockoutObservable<boolean>;
}

export class HyperlinkFieldsProperty extends BaseProperty {
    Enabled: KnockoutObservable<boolean>;
    Options: KnockoutObservableArray<IOptionItem>;

    constructor(property: IPropertyDescription, propertyValue: IHyperlinkFieldsValue, control: IControl, isEnabled: boolean = true) {
        super(property, isEnabled);

        const init = this.Normalize(propertyValue);

        this.Enabled = ko.observable(!!init.Enabled);
        this.Options = ko.observableArray<IOptionItem>([]);

        if (control) {
            const attachedFields = control.GetModel().Fields || [];
            const options: IOptionItem[] = _.map(attachedFields, (field: AttachedFieldModel) => ({
                Name: field.FieldNameTranslation || field.Name,
                Value: field.Id,
                IsSelected: ko.observable(_.contains(init.FieldIds, field.Id))
            }));
            this.Options(options);
        }

        this.Value = ko.computed<IHyperlinkFieldsValue>({
            read: () => ({
                Enabled: !!this.Enabled(),
                FieldIds: _.chain(this.Options())
                    .filter(o => !!o.IsSelected())
                    .map(o => o.Value)
                    .value()
            }),
            write: (value: IHyperlinkFieldsValue) => {
                const normalized = this.Normalize(value);
                this.Enabled(!!normalized.Enabled);
                _.each(this.Options(), o => o.IsSelected(_.contains(normalized.FieldIds, o.Value)));
            }
        }) as any;
    }

    GetTemplateName(): string {
        return "Core/GeneralProperties/Managers/HyperlinkFieldsProperty/Templates/HyperlinkFieldsProperty";
    }

    GetDefaultValue(): IHyperlinkFieldsValue {
        return { Enabled: false, FieldIds: [] };
    }

    SetValue(propertyValue: IHyperlinkFieldsValue): void {
        this.Value(propertyValue);
    }

    private Normalize(value: any): IHyperlinkFieldsValue {
        if (!value) {
            return this.GetDefaultValue();
        }

        return {
            Enabled: !!value.Enabled,
            FieldIds: _.isArray(value.FieldIds) ? value.FieldIds.slice() : []
        };
    }
}
